export default __webpack_public_path__ + "static/transit_and_atrest-3a1bec196ebafdd07546f3f98c6f51f8.png";